import React, { useState, useEffect, useCallback } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  CircularProgress,
  Box,
} from "@mui/material";
import { format } from "date-fns";
import { useTranslation } from "react-i18next";
// import { api } from "../services/api";

const AccountActivity = () => {
  const { t } = useTranslation();
  const [activities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchAccountActivity = useCallback(async () => {
    try {
      setLoading(true);
      // const response = await api.get("/user/activity");
      // setActivities(response.data);
      return false; // TO-DO update backend with new api
    } catch (err) {
      setError(t("errors.fetchActivityFailed"));
    } finally {
      setLoading(false);
    }
  }, [t]);

  useEffect(() => {
    fetchAccountActivity();
  }, [fetchAccountActivity]);

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" p={3}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    return (
      <Typography color="error" align="center">
        {error}
      </Typography>
    );
  }

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t("accountActivity.date")}</TableCell>
          <TableCell>{t("accountActivity.activity")}</TableCell>
          <TableCell>{t("accountActivity.ipAddress")}</TableCell>
          <TableCell>{t("accountActivity.status")}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {activities.map((activity) => (
          <TableRow key={activity.id}>
            <TableCell>{format(new Date(activity.timestamp), "PPp")}</TableCell>
            <TableCell>{activity.description}</TableCell>
            <TableCell>{activity.ipAddress}</TableCell>
            <TableCell>{activity.status}</TableCell>
          </TableRow>
        ))}
      </TableBody>
    </Table>
  );
};

export default AccountActivity;
